module.exports = __webpack_public_path__ + "media/images/icons/instagram-white-c3e725ebd0ff4545549307d966fd12dd.svg";